import { Division } from "@ir/ui";

const ProgressBar = () => {
  return (
    <Division className="progress-bar">
      <Division className="progress-bar-progress"></Division>
    </Division>
  );
};

export default ProgressBar;
